// extracted by mini-css-extract-plugin
module.exports = {"optionContainer":"styles_optionContainer__3A3H-","_label":"styles__label__FWH9x","selector":"styles_selector__3b7HK"};